import { LanguagesConfig } from '../models';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const DEFAULT_LANGUAGE = 'en';
const LANGUAGE_QUERY_PARAM = 'lang';
const LANGUAGE_KEY_CODE = 'language';

export class TranslationsService {
  private availableLanguages: string[] = [];
  private currentLanguage = DEFAULT_LANGUAGE;

  getAvailableLanguages(): string[] {
    return this.availableLanguages;
  }

  getCurrentLanguage(): string {
    return this.currentLanguage;
  }

  async changeLanguage(lang: string): Promise<void> {
    if (!this.availableLanguages.includes(lang)) {
      return;
    }

    window.localStorage.setItem(LANGUAGE_KEY_CODE, lang);
    this.currentLanguage = lang;

    await i18n.changeLanguage(lang);
    this.updateBrowserTabTitle();

    const url = new URL(location.href);
    url.searchParams.set(LANGUAGE_QUERY_PARAM, lang);
    history.pushState(null, '', url);
  }

  async initTranslations(
    languages: LanguagesConfig,
    defaultLanguage: string,
  ): Promise<void> {
    const langParam = (
      new URLSearchParams(window.location.search).get(LANGUAGE_QUERY_PARAM) ||
      window.localStorage.getItem(LANGUAGE_KEY_CODE) ||
      defaultLanguage
    ).toLowerCase();
    this.availableLanguages = Object.keys(languages);
    this.currentLanguage = this.availableLanguages.includes(langParam)
      ? langParam
      : DEFAULT_LANGUAGE;

    await i18n.use(initReactI18next).init({
      resources: {
        ...languages,
      },
      lng: this.currentLanguage,
      fallbackLng: DEFAULT_LANGUAGE,
      lowerCaseLng: true,

      interpolation: {
        escapeValue: false,
      },
    });

    this.updateBrowserTabTitle();
  }

  private updateBrowserTabTitle(): void {
    const title = i18n.t('browserTabTitle', { defaultValue: '' });
    if (title) {
      document.title = title;
    }
  }
}

export const translationsService = new TranslationsService();
